import UsageService from '@/services/common/UsageService';

const usageServiceInstance = new UsageService();

export const getSummarySecurityLogs = async ({ commit }: { commit: Function }, payload: any) => {
    commit('isFetchingSummary', true);
    commit('summaryError', '');
    try {
        const summarySecurityLogs = await usageServiceInstance.getSummarySecurityLogs(payload.selectedMonth, payload.excludeTestOrgs);
        commit('summarySecurityLogs', summarySecurityLogs);
    } catch (err: any) {
        commit('summaryError', err?.message || 'Failed to load usage summary.');
    } finally {
        commit('isFetchingSummary', false);
    }
}

export const getCustomerUsers = async (_ctx: any, payload: any) => {
    return await usageServiceInstance.getCustomerUsers(payload.customerId, payload.selectedMonth, payload.excludeTestOrgs);
}

export const getPublishTrend = async (_ctx: any, payload: any) => {
    return await usageServiceInstance.getPublishTrend(payload.selectedMonth, payload.excludeTestOrgs);
}

export const getCustomerActiveUsers = async (_ctx: any, payload: any) => {
    return await usageServiceInstance.getCustomerActiveUsers(payload.customerId, payload.months);
}
